"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tab-title-page"
  }, [_c("div", {
    staticClass: "nav_tabs"
  }, [_c("el-tabs", {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "基础信息",
      name: "main"
    }
  }), _c("el-tab-pane", {
    attrs: {
      label: "配置设置",
      name: "config"
    }
  })], 1)], 1), _c("el-divider", {
    staticClass: "middle_divider"
  }), _c("div", {
    staticClass: "child_page"
  }, [_c("mianInfo", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeName === "main",
      expression: "activeName === 'main'"
    }],
    ref: "mianInfo",
    attrs: {
      id: _vm.id
    }
  }), _c("configInfo", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeName === "config",
      expression: "activeName === 'config'"
    }],
    ref: "configInfo"
  })], 1)], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;